module.exports = __webpack_public_path__ + "static/1-2111879a21ac6b5eacb5e750bc86997f.gif";